export default __webpack_public_path__ + "static/media/gozdem1.bf74e913.jpg";